/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Error_MicrophoneInputs */



/**
* | output |
* | --- |
* | "Microphone access denied. Please enable it in your browser settings." |
*
* @param {Voice_Error_MicrophoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_microphone = /** @type {((inputs?: Voice_Error_MicrophoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_MicrophoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mikrofonzugriff verweigert. Bitte aktivieren Sie ihn in Ihren Browser-Einstellungen.")
	return /** @type {LocalizedString} */ ("Microphone access denied. Please enable it in your browser settings.")
});